import { AppointableDTO } from "@gymflow/types";

export const appointableHelper = {
  /*** Gets the appointable host if there's only one available */
  getSingleHost: (appointable?: AppointableDTO) => {
    return appointable
      ? appointable.availabilityType === "FACILITY" &&
        appointable.appointableFacilities.length === 1
        ? appointable.appointableFacilities[0].id
        : appointable.availabilityType === "STAFF" &&
            appointable.appointableHosts.length === 1
          ? appointable.appointableHosts[0].id
          : undefined
      : undefined;
  },
};
